import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeak = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3334 6.66658V4.53325C13.3334 3.41315 13.3334 2.85309 13.1154 2.42527C12.9236 2.04895 12.6177 1.74299 12.2413 1.55124C11.8135 1.33325 11.2535 1.33325 10.1334 1.33325H5.86669C4.74658 1.33325 4.18653 1.33325 3.75871 1.55124C3.38238 1.74299 3.07642 2.04895 2.88467 2.42527C2.66669 2.85309 2.66669 3.41315 2.66669 4.53325V11.4666C2.66669 12.5867 2.66669 13.1467 2.88467 13.5746C3.07642 13.9509 3.38238 14.2569 3.75871 14.4486C4.18653 14.6666 4.74658 14.6666 5.86669 14.6666H8.00002",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3652 11.0508C13.7966 11.7659 14.3421 12.5547 13.7182 13.3814C13.0942 14.2082 10.9014 14.2042 10.2805 13.3814C9.65958 12.5587 10.2021 11.7659 10.6334 11.0508C11.0648 10.3357 11.9993 8.66667 11.9993 8.66667C11.9993 8.66667 12.9339 10.3357 13.3652 11.0508Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33331 7.33341H5.33331M6.66665 10.0001H5.33331M10.6666 4.66675H5.33331",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLeak;
